module.exports = __webpack_public_path__ + "static/media/payroll.90c56c21.svg";